module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "stockinfo",
    staticClass: "topWrap clearfix",
    attrs: {
      "id": "stockinfo"
    }
  }, [_c('div', {
    staticClass: "stockInfo",
    style: (_vm.CellStyle[0])
  }, [_c('p', {
    staticClass: "stockName"
  }, [_c('span', {
    staticClass: "nameText"
  }, [_vm._v(_vm._s(_vm.StockData.Name.Text))]), _vm._v(" "), (_vm.StockData.IsMargin) ? _c('span', {
    attrs: {
      "title": "融资融券标的"
    }
  }, [_c('svg', {
    staticClass: "symbolIkcon iconStockinfo",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-margin"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.StockData.IsSHHK) ? _c('span', {
    attrs: {
      "title": "沪港通标的"
    }
  }, [_c('svg', {
    staticClass: "symbolIkcon iconStockinfo",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shhk"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.StockData.IsHK) ? _c('span', {
    attrs: {
      "title": "AH股\n港股：" + _vm.StockData.HK.Symbol
    }
  }, [_c('svg', {
    staticClass: "symbolIkcon iconStockinfo",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-hk"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.IsStockStar) ? _c('span', {
    attrs: {
      "title": _vm.科创板
    }
  }, [_c('svg', {
    staticClass: "symbolIkcon iconStockinfo",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-stockStar"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "codeInfo"
  }, [_c('span', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.Symbol))]), _vm._v(" "), (_vm.IsShow.IconStyle) ? _c('button', {
    staticClass: "searchBtn",
    on: {
      "click": _vm.GoSearch
    }
  }, [_vm._v("股票查询")]) : _vm._e(), _vm._v(" "), (!_vm.IsShow.IconStyle) ? _c('button', {
    staticClass: "cancelBtn",
    on: {
      "click": _vm.CancelSearch
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsShow.SearchSymbol),
      expression: "IsShow.SearchSymbol"
    }],
    staticClass: "editSymbol"
  }, [_c('SearchSymbol', {
    ref: "mySymbol",
    on: {
      "inputValue": _vm.OnChangeSymbol
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "priceInfo",
    style: (_vm.CellStyle[1])
  }, [_c('p', {
    staticClass: "priceCurrentNum",
    class: _vm.StockData.Price.Color
  }, [_vm._v(_vm._s(_vm.StockData.Price.Text))]), _vm._v(" "), _c('p', {
    staticClass: "priceCurrent"
  }, [_c('span', {
    staticClass: "riseNum",
    class: _vm.StockData.RiseFallPrice.Color
  }, [_vm._v(_vm._s(_vm.StockData.RiseFallPrice.Text))]), _c('span', {
    staticClass: "risePrecent",
    class: _vm.StockData.Increase.Color
  }, [_vm._v(_vm._s(_vm.StockData.Increase.Text))])])]), _vm._v(" "), _c('div', {
    staticClass: "otherInfo",
    style: (_vm.CellStyle[2])
  }, [_c('div', {
    staticClass: "high"
  }, [_vm._v("最高："), _c('span', {
    class: _vm.StockData.High.Color
  }, [_vm._v(_vm._s(_vm.StockData.High.Text))])]), _vm._v(" "), _c('div', {
    staticClass: "low"
  }, [_vm._v("最低："), _c('span', {
    class: _vm.StockData.Low.Color
  }, [_vm._v(_vm._s(_vm.StockData.Low.Text))])])]), _vm._v(" "), _c('div', {
    staticClass: "otherInfo",
    style: (_vm.CellStyle[3])
  }, [_c('div', {
    staticClass: "open"
  }, [_vm._v("今开："), _c('span', {
    class: _vm.StockData.Open.Color
  }, [_vm._v(_vm._s(_vm.StockData.Open.Text))])]), _vm._v(" "), (_vm.IsIndex == false ? true : false) ? _c('div', {
    staticClass: "change"
  }, [_vm._v("换手："), _c('span', {
    class: _vm.StockData.Excahngerate.Color
  }, [_vm._v(_vm._s(_vm.StockData.Excahngerate.Text))])]) : _vm._e(), _vm._v(" "), (_vm.IsIndex == true ? true : false) ? _c('div', {
    staticClass: "change"
  }, [_vm._v("昨收："), _c('span', [_vm._v(_vm._s(_vm.StockData.YClose.Text))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "otherInfo",
    style: (_vm.CellStyle[4])
  }, [_c('div', {
    staticClass: "num"
  }, [_vm._v("成交额："), _c('span', [_vm._v(_vm._s(_vm.StockData.Amount.Text))])]), _vm._v(" "), _c('div', {
    staticClass: "totalValue"
  }, [_vm._v("成交量："), _c('span', [_vm._v(_vm._s(_vm.StockData.Vol.Text))])])]), _vm._v(" "), _c('div', {
    staticClass: "otherInfo",
    style: (_vm.CellStyle[5])
  }, [(_vm.IsIndex == false ? true : false) ? _c('div', {
    staticClass: "pe"
  }, [_vm._v("PE："), _c('span', [_vm._v(_vm._s(_vm.StockData.Pe.Text))])]) : _vm._e(), _vm._v(" "), (_vm.IsIndex == false ? true : false) ? _c('div', {
    staticClass: "roe"
  }, [_vm._v("ROE："), _c('span', {
    class: _vm.StockData.Roe.Color
  }, [_vm._v(_vm._s(_vm.StockData.Roe.Text))])]) : _vm._e(), _vm._v(" "), (_vm.IsIndex == true ? true : false) ? _c('div', {
    staticClass: "change"
  }, [_vm._v("上涨家数："), _c('span', [_vm._v(_vm._s(_vm.StockData.Up.Text))])]) : _vm._e(), _vm._v(" "), (_vm.IsIndex == true ? true : false) ? _c('div', {
    staticClass: "change"
  }, [_vm._v("下跌家数："), _c('span', [_vm._v(_vm._s(_vm.StockData.Down.Text))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "otherInfo",
    style: (_vm.CellStyle[6])
  }, [(_vm.IsIndex == true ? true : false) ? _c('div', {
    staticClass: "marketV"
  }, [_vm._v("平盘："), _c('span', [_vm._v(_vm._s(_vm.StockData.Unchanged.Text))])]) : _vm._e(), _vm._v(" "), (_vm.IsIndex == false ? true : false) ? _c('div', {
    staticClass: "marketV"
  }, [_vm._v("总市值："), _c('span', [_vm._v(_vm._s(_vm.StockData.MarketV.Text))])]) : _vm._e(), _vm._v(" "), (_vm.IsIndex == false ? true : false) ? _c('div', {
    staticClass: "flowMarketV"
  }, [_vm._v("流通市值："), _c('span', [_vm._v(_vm._s(_vm.StockData.FlowMarketV.Text))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "otherInfo",
    style: (_vm.CellStyle[7])
  }, [(_vm.IsIndex == false ? true : false) ? _c('div', {
    staticClass: "eps"
  }, [_vm._v("EPS："), _c('span', [_vm._v(_vm._s(_vm.StockData.Eps.Text))])]) : _vm._e(), _vm._v(" "), (_vm.IsIndex == false ? true : false) ? _c('div', {
    staticClass: "scrollEPS"
  }, [_vm._v("EPS(动)："), _c('span', [_vm._v(_vm._s(_vm.StockData.ScrollEPS.Text))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "otherInfo",
    style: (_vm.CellStyle[8])
  }, [(_vm.IsIndex == false ? true : false) ? _c('div', {
    staticClass: "pb"
  }, [_vm._v("PB："), _c('span', [_vm._v(_vm._s(_vm.StockData.Pb.Text))])]) : _vm._e(), _vm._v(" "), (_vm.IsIndex == false ? true : false) ? _c('div', {
    staticClass: "amplitude"
  }, [_vm._v("振幅："), _c('span', [_vm._v(_vm._s(_vm.StockData.Amplitude.Text))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89aa10d4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/jscommon/umychart.vue.components/stockinfo.vue
// module id = 129
// module chunks = 0 1 3 5 8